module.exports = require('./lib/marvel-ui-toggle.js');



//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/toggle.js
// module id = 520
// module chunks = 18116671869107 156544657062075